<h2 mat-dialog-title>Pré-Visualizar Talão</h2>

<mat-dialog-content class="mat-typography">
  <pre [innerHTML]="data.receipt"></pre>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Fechar</button>
</mat-dialog-actions>
